import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "SectionTitlestyles__Container",
  componentId: "keen-widget-settings__sc-1j4gzg0-0"
})(["&&&{margin-bottom:20px;}"]);
export var Header = styled.div.withConfig({
  displayName: "SectionTitlestyles__Header",
  componentId: "keen-widget-settings__sc-1j4gzg0-1"
})(["&&&{display:flex;align-items:center;justify-content:space-between;height:28px;width:100%;max-width:500px;}"]);